import React from 'react';
import styled, {keyframes} from 'styled-components';
import {Theme} from "../../../../../../../contexts/operator/operator-context";
import {rgba} from "polished";

interface QuantityButtonProps {
    quantity: number;
    setQuantity: (quantity: number) => void;
    type: 'large' | 'small';
    minimum?: boolean
}

const QuantityButton = ({ quantity, setQuantity, type, minimum = false }: QuantityButtonProps) => {
    return (
        <QuantityButtonWrapper className='quantity-btn' type={type}>
            <button
                onClick={(e) =>  {
                    e.stopPropagation();
                    if ( quantity > 1 || !minimum ) {
                        setQuantity(quantity - 1)
                    }
                    return null;
                }}
                className={!minimum || quantity > 1 ? '' : 'disabled'}
                disabled={minimum && quantity <= 1}
                data-testid="dec-item-qty"
            >
                <span className="material-symbols-outlined">do_not_disturb_on</span>
            </button>
            <span data-testid="val-item-qty">
                {quantity}
            </span>
            <button onClick={(e) => {
                e.stopPropagation();
                setQuantity(quantity + 1)
            }} data-testid="inc-item-qty">
                <span className="material-symbols-outlined">add_circle</span>
            </button>
        </QuantityButtonWrapper>
    );
};

const QuantityButtonWrapper = styled.div<{type: 'large' | 'small'}>`
    display: flex;
    align-items: center;
    flex-grow: 0;
    gap: 4px;
    margin: 0;
    padding: 0;
    span {
        margin: 0 8px;
        width: 20px;
        height: 20px;
        line-height: 20px;
        display: inline-flex;
        text-align: center;
        justify-content: center;
    }
    button {
        outline: none;
        background-color: transparent;
        height: 16px;
        width: 16px;
        position: relative;
        border: 0;
        padding: 0;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: var(--color_ui_5);
        transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out;

        &.disabled {
            pointer-events: none;
            color: var(--bg-disabled);
        }
    }

    ${(props) => props.type === "large" ? `
        gap: 24px;
        span {
            width: 36px;
            height: 24px;
            font-size: 24px;
            font-weight: 600;
            line-height: 24px;

            &.material-symbols-outlined {
                font-weight: unset;
            }
        }
        button {
            height: 24px;
            width: 24px;
        }
    ` : ''}
`;

export default QuantityButton;
